import { Button, styled, CircularProgress } from "@mui/material";
import type { CustomButtonProps, StyledButtonProps } from "./types/CustomButton.types";

const CustomButton: React.FC<CustomButtonProps> = ({
  text,
  variant = "contained",
  width = "100%",
  type,
  startIcon,
  height = "100%",
  disabled,
  onClick,
  fontWeight,
  loading = false, 
  border,
  background
}) => {
  const StyledButton = styled(Button)<StyledButtonProps>(() => ({
    textTransform: "capitalize",
    fontFamily: "var(--Outfit)",
    fontSize: "16px",
    letterSpacing:"0.3px",
    fontWeight: fontWeight ?? 500,
    lineHeight: "100%",
    color: "#2C2C2C",
    padding: "14px",
    border:border ?? 0,
    borderRadius: "8px",
    // opacity:"50%",
    width,
    height,
    background:background ?? "#ffffff",
    "&:hover": background ?? {
      background:"#ffffff",
    },
    display: "flex",
    gap: "4px", // Add gap between icon and text/loader
    "& .MuiCircularProgress-root": {
      color: "#FFFFFF",
      width: "20px !important",
      height: "20px !important",
    },
    "&.Mui-disabled": {
      background: "#EBA832",
      opacity: 0.5,
      color: "#2C2C2C"
    },
  }));

  return (
    <StyledButton
      variant={variant}
      disableElevation={true}
      width={width}
      type={type}
      startIcon={loading ? <CircularProgress /> : startIcon}
      disabled={disabled || loading}
      onClick={onClick}
    >
      {loading ? "" : text}
    </StyledButton>
  );
};

export default CustomButton;